import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const alexanderProperty = new SummonDataProperty(
  "6fa92098-e7fc-4ac9-a11a-6af72f47d1e4",
  "Alexander",
)
